<template>
    <div class="container">
        <img src="../assets/img/404.png" alt="">
    </div>
</template>

<script >
export default {
    name: 'error404',
    components:{},
    props:{}
}
</script>

<style lang="scss" scoped>

</style>